import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./DeviceDetails.module.scss";
import { dispatchTradeInYourDevice } from "../analytics";
import DeviceIcon from "../../DeviceIcon/DeviceIcon";

type DeviceDetailsProps = {
  category: string;
  description: string;
  maximumDisplayValue: string;
  onTradeInDevice: () => void;
};

const DeviceDetails = ({
  category,
  description,
  maximumDisplayValue,
  onTradeInDevice,
}: DeviceDetailsProps) => {
  const handleTradeInDevice = () => {
    dispatchTradeInYourDevice();
    onTradeInDevice();
  };

  return (
    <div className={styles.deviceDetails}>
      <h2 className={styles.deviceDetails__title}>Your device</h2>
      <div className={styles.deviceDetailsWrapper}>
        <div className={styles.deviceDetailsCard} data-cy="device-details">
          <div className={styles.deviceDetailsCard__columnsWrapper}>
            <div className={styles.deviceDetailsCard__leftCol}>
              <DeviceIcon category={category} />
            </div>
            <div className={styles.deviceDetailsCard__rightCol}>
              <h3 className={styles.deviceDetailsCard__description}>
                {description}
              </h3>
              <p className={styles.deviceDetailsCard__maxValue}>
                Receive up to{" "}
                <span data-cy="maximum-value">{maximumDisplayValue}*</span>
              </p>
            </div>
          </div>
          <PrimaryButton
            data-cy="trade-in-device"
            type="button"
            onClick={handleTradeInDevice}
          >
            Trade in your device
          </PrimaryButton>
          <p className={styles.deviceDetailsCard__note}>
            * The condition of your device will affect its value upon final
            evaluation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeviceDetails;
